import React from 'react';
import { Typography, IconButton, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../../../context/authContext';

const LogoutTimer = () => {
  const { sessionTimeRemaining, isCounterDevice, logout } = useAuth();

  if (!isCounterDevice || sessionTimeRemaining <= 0) {
    return null;
  }

  const minutes = Math.floor(sessionTimeRemaining / 60);
  const seconds = sessionTimeRemaining % 60;

  return (
    <IconButton
      onClick={logout}
      sx={{
        color: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
      size='small'
    >
      <Typography variant='body2' sx={{ color: 'inherit', mr: 0.5 }}>
        {`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}
      </Typography>
      <LockIcon fontSize='small' />
    </IconButton>
  );
};

export default LogoutTimer;
